import { FlexBox } from "@brg/ui";
import { LayoutConst } from "core";
import styled, { css } from "styled-components";

export const TgMessage = styled.div`
    color: ${(p) => p.theme.sendProjectsModal.label};
`;

export const RadioText = styled.div`
    color: ${(p) => p.theme.sendProjectsModal.label};
`;

export const FieldsContainer = styled(FlexBox)`
    .add-button, .content-container, .input-container, .brg-input__control {
        width: 100%;
        max-width: 700px;
        min-width: 700px;
    }

    .image-format {
        padding-top: 16px;
        color: #909090;
        font-size: 11px;
        line-height: 13px;
    }

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        .add-button, .content-container, .input-container, .brg-input__control  {
            width: 100%;
            max-width: 564px;
            min-width: 564px;
        }
    }

    @media (max-width: ${LayoutConst.screen.s -1}px) {
        .add-button, .content-container, .input-container, .brg-input__control  {
            width: 100%;
            max-width: 100%;
            min-width: 100%;
        }
    }
`;

export const OuterContainer = styled.div`
    .info-wrapper {
        margin: 0 auto;
        transform: translate(50%, 50%);
        @media (max-width: ${LayoutConst.screen.md}px) {
                transform: translate(0%, 50%);
        }
    }

    @media (max-width: ${LayoutConst.screen.m}px) {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        min-height: 85vh;

        .info-wrapper {
            width: 100%;
            max-width: 100%;
            position: relative;
            top: auto;
            left: auto;
            transform: none;
            margin: 0 auto;
        }
    }
`;

export const SubmitButton = styled.button<{ hide?: boolean }>`
    cursor: pointer;
    background-color: #151514;
    color: #fff;
    padding: 12px 48px;
    font-family: Inter;
    font-size: 17px;
    font-weight: 600;
    line-height: 22px;
    -webkit-letter-spacing: -0.02em;
    -moz-letter-spacing: -0.02em;
    -ms-letter-spacing: -0.02em;
    letter-spacing: -0.02em;
    text-align: center;
    border-radius: 3px;
    max-width: 190px;
    border-color: transparent;
    margin-top: 50px !important;

    ${({ hide, theme }) => hide && css`
        cursor: not-allowed;
        color: ${theme.navigationBar.btns.filled.text.disabled};
        background: ${theme.navigationBar.btns.filled.background.disabled}; 
        pointer-events: none;
    `};
`;
import { FlexBox } from "@brg/ui";
import { LayoutConst } from "core";
import styled, { css } from "styled-components";

export const TgMessage = styled.div`
    color: ${(p) => p.theme.sendProjectsModal.label};
`;

export const RadioText = styled.div`
    color: ${(p) => p.theme.sendProjectsModal.label};
`;

export const FieldsContainer = styled(FlexBox)`
    .add-button, .content-container, .input-container, .brg-input__control {
        width: 100%;
        max-width: 700px;
        min-width: 700px;
    }

    .image-format {
        padding-top: 16px;
        color: #909090;
        font-size: 11px;
        line-height: 13px;
    }

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        .add-button, .content-container, .input-container, .brg-input__control  {
            width: 100%;
            max-width: 564px;
            min-width: 564px;
        }
    }

    @media (max-width: ${LayoutConst.screen.s -1}px) {
        .add-button, .content-container, .input-container, .brg-input__control  {
            width: 100%;
            max-width: 100%;
            min-width: 100%;
        }
    }
`;

export const OuterContainer = styled.div`
    .info-wrapper {
        margin: 0 auto;
        transform: translate(50%, 50%);
        @media (max-width: ${LayoutConst.screen.md}px) {
                transform: translate(0%, 50%);
        }
    }

    @media (max-width: ${LayoutConst.screen.m}px) {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        min-height: 85vh;

        .info-wrapper {
            width: 100%;
            max-width: 100%;
            position: relative;
            top: auto;
            left: auto;
            transform: none;
            margin: 0 auto;
        }
    }
`;

export const SubmitButton = styled.button<{ hide?: boolean }>`
    cursor: pointer;
    background-color: #151514;
    color: #fff;
    padding: 12px 48px;
    font-family: Inter;
    font-size: 17px;
    font-weight: 600;
    line-height: 22px;
    -webkit-letter-spacing: -0.02em;
    -moz-letter-spacing: -0.02em;
    -ms-letter-spacing: -0.02em;
    letter-spacing: -0.02em;
    text-align: center;
    border-radius: 3px;
    max-width: 190px;
    border-color: transparent;
    margin-top: 50px !important;

    ${({ hide, theme }) => hide && css`
        cursor: not-allowed;
        color: ${theme.navigationBar.btns.filled.text.disabled};
        background: ${theme.navigationBar.btns.filled.background.disabled}; 
        pointer-events: none;
    `};
`;
